import { Type } from '@sinclair/typebox';
export const errorResponse = Type.String();
//# sourceMappingURL=shared.js.map